import { Divider, Paper } from '@mui/material';
import { MemreButton, MemreFlexBox } from 'components/core';
import { MemreRTE } from 'components/core';
import Sound from './Sound';

export default function Step({
  text,
  id,
  image,
  sound,
  dragHandle,
  deleteImage,
  deleteStep,
  setText,
  handleAddImage,
  addSound,
  deleteSound,
}) {
  const disabled = id.includes('placeholder');

  const imageUrl = image?.smallUrl ?? image?.url;
  return (
    <Paper
      component="form"
      key={id}
      sx={{
        p: '2px 8px 2px 4px',
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #767676',
        opacity: disabled ? 0.3 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
        minHeight: '60px',
      }}
    >
      <MemreFlexBox direction="column" sx={{ p: 1, display: 'flex', alignItems: 'center' }}>
        {dragHandle}
      </MemreFlexBox>
      <Divider sx={{ height: '40px', m: 0.5 }} orientation="vertical" />
      <MemreFlexBox direction="column" sx={{ flex: 1 }}>
        <MemreRTE initialContent={text} onUpdate={setText} placeholder="Answer Text" id={`$answer-${id}`} />
      </MemreFlexBox>
      <Divider sx={{ height: '40px', m: 0.5 }} orientation="vertical" />
      <Sound url={sound?.url} add={addSound} handleDelete={deleteSound} iconOnly={true} />
      <div style={{ width: '12px' }} />
      {imageUrl && (
        <MemreFlexBox direction="column" sx={{ position: 'relative', height: '56px' }} align="center" justify="center">
          <div
            style={{
              aspectRatio: '1/1',
              height: '56px',
              backgroundImage: `url(${imageUrl})`,
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              borderRadius: '4px',
            }}
          />
          <MemreButton
            variant="icon"
            iconName="trash"
            onClick={deleteImage}
            sx={{ position: 'absolute', backgroundColor: 'white' }}
          />
        </MemreFlexBox>
      )}
      {!imageUrl && <MemreButton variant="icon" iconName="image" onClick={() => handleAddImage(image.add)} />}
      <div style={{ width: '24px' }} />

      <MemreButton variant="icon" iconName="trash" onClick={deleteStep} />
    </Paper>
  );
}
